import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export default function HotelSearch() {
  const nav = useNavigate();
  const [lang, setLang] = useState<"en"|"ar">("en");
  const [destination, setDestination] = useState("Dubai");
  const [checkIn, setCheckIn] = useState("");
  const [checkOut, setCheckOut] = useState("");
  const [rooms, setRooms] = useState(1);
  const [adults, setAdults] = useState(2);
  const [loading, setLoading] = useState(false);
  const t = (en:string, ar:string)=> lang==="en"?en:ar;

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);

    const payload = {
      destination: { query: destination },
      check_in_date: checkIn,
      check_out_date: checkOut,
      rooms: [{ adults }],
      currency: "AED"
    };

    try {
      const { data, error } = await supabase.functions.invoke('stays-search', {
        body: payload
      });
      
      setLoading(false);

      if (error) {
        console.error('Hotel search error:', error);
        alert(t("Search failed. Please try again.", "فشل البحث. يرجى المحاولة مرة أخرى."));
        return;
      }

      if (data?.data?.offers) {
        nav("/stays/results", { 
          state: { 
            offers: data.data.offers, 
            search: { destination, checkIn, checkOut, rooms, adults } 
          } 
        });
      } else {
        alert(t("No hotels found. Try different dates.", "لا توجد فنادق. جرّب تواريخ أخرى."));
      }
    } catch (error) {
      setLoading(false);
      console.error('Hotel search error:', error);
      alert(t("Search failed. Please try again.", "فشل البحث. يرجى المحاولة مرة أخرى."));
    }
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-5xl mx-auto p-6">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-heading font-semibold text-flexaura-navy">
            {t("Flexaura Hotels", "فليكساورا للفنادق")}
          </h1>
          <div className="flex gap-2">
            <button 
              onClick={()=>setLang("en")} 
              className={`px-3 py-1 rounded-xl border smooth-transition ${
                lang==="en"
                  ? "bg-primary text-primary-foreground border-primary" 
                  : "bg-background text-foreground border-border hover:bg-muted"
              }`}
            >
              EN
            </button>
            <button 
              onClick={()=>setLang("ar")} 
              className={`px-3 py-1 rounded-xl border smooth-transition ${
                lang==="ar"
                  ? "bg-primary text-primary-foreground border-primary" 
                  : "bg-background text-foreground border-border hover:bg-muted"
              }`}
            >
              AR
            </button>
          </div>
        </div>

        <form onSubmit={onSubmit} className="bg-card border border-border rounded-2xl p-5 card-shadow">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
            <input 
              value={destination} 
              onChange={e=>setDestination(e.target.value)}
              placeholder={t("Destination", "الوجهة")}
              className="rounded-2xl border border-input bg-background px-3 py-3 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 smooth-transition" 
            />
            <input 
              type="date" 
              value={checkIn} 
              onChange={e=>setCheckIn(e.target.value)}
              className="rounded-2xl border border-input bg-background px-3 py-3 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 smooth-transition" 
            />
            <input 
              type="date" 
              value={checkOut} 
              onChange={e=>setCheckOut(e.target.value)}
              className="rounded-2xl border border-input bg-background px-3 py-3 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 smooth-transition" 
            />
            <input 
              type="number" 
              min={1} 
              value={rooms} 
              onChange={e=>setRooms(parseInt(e.target.value||"1"))}
              className="rounded-2xl border border-input bg-background px-3 py-3 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 smooth-transition" 
              placeholder={t("Rooms", "غرف")} 
            />
            <input 
              type="number" 
              min={1} 
              value={adults} 
              onChange={e=>setAdults(parseInt(e.target.value||"1"))}
              className="rounded-2xl border border-input bg-background px-3 py-3 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 smooth-transition" 
              placeholder={t("Adults", "بالغون")} 
            />
          </div>
          <div className="mt-4">
            <button 
              disabled={loading}
              className="px-6 py-3 rounded-2xl font-medium text-white gradient-bg hover:opacity-90 smooth-transition disabled:opacity-50"
            >
              {loading ? t("Searching...", "جارٍ البحث...") : t("Search Hotels", "ابحث عن فنادق")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}